import React, { useState } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './style.scss'
interface FormProps {
    pdfUrl?: any;
}

const PdfViewerComponent = ({ pdfUrl }: FormProps) => {
    return (
        <div>
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.0.279/build/pdf.worker.min.js`}>
            <div style={{ maxHeight: '500px',width: '100%', overflowY: 'auto'}} className="custom-scrollbar">
                    <Viewer fileUrl={pdfUrl} />
                </div>
            </Worker>
        </div>
    );
};

export default PdfViewerComponent;
